import { useCallback, useEffect, useRef, useState } from 'react';

export default function useCopyFeedback(duration = 2000) {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout>();

    const showCopyFeedback = useCallback(() => {
        setCopied(true);

        // Clear existing timeout if any
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setCopied(false);
        }, duration);
    }, [duration]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return { copied, showCopyFeedback };
}
